export const LOCALES = {
  'zh-CN': '简体中文',
  'en-US': 'English(US)',
  'ar-MA': 'العربية (المغرب)',
  'ar-SA': 'العربية (السعودية)',
  'cs-CZ': 'Čeština',
  'de-DE': 'Deutsch',
  'en-GB': 'English(GB)',
  'es-419': 'Español (Latinoamérica)',
  'es-ES': 'Español (España)',
  'fr-FR': 'Français',
  'id-ID': 'Bahasa Indonesia',
  'it-IT': 'Italiano',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'ms-MY': 'Bahasa Melayu',
  'pl-PL': 'Polski',
  'ro-RO': 'Română',
  'ru-RU': 'Русский язык',
  'th-TH': 'ภาษาไทย',
  'tr-TR': 'Türkçe',
  'ur-PK': 'اردو',
  'vi-VN': 'Tiếng Việt',
  'zh-HK': '繁體中文(香港)',
  'zh-TW': '繁體中文(台灣)'
} as const;

export type TLocale = keyof typeof LOCALES;

/**
 * 获取语言选项
 * @param langs 语言列表
 * @returns 语言选项
 */
function getLangOptions(langs: TLocale[]): ILangConfig[] {
  return langs.map((lang) => ({
    label: LOCALES[lang],
    value: lang
  }));
}

/** 所有可选语言列表 */
const allLangOptions: ILangConfig[] = getLangOptions([...Object.keys(LOCALES)] as TLocale[]);

/** 新零售支持语言配置 */
const newRetailLangOptions: ILangConfig[] = getLangOptions([
  'zh-CN',
  'en-US',
  'en-GB',
  'cs-CZ',
  'de-DE',
  'es-419',
  'es-ES',
  'fr-FR',
  'id-ID',
  'ja-JP',
  'ko-KR',
  'ms-MY',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'th-TH',
  'vi-VN',
  'zh-HK',
  'zh-TW'
]);

/** 中英双语语言列表 */
const dualLangOptions: ILangConfig[] = getLangOptions(['zh-CN', 'en-US']);

/** 知识库可选语言列表 */
const trainingLangOptions: ILangConfig[] = getLangOptions([
  'zh-CN',
  'en-US',
  'ar-MA',
  'es-419',
  'es-ES',
  'fr-FR',
  'id-ID',
  'ja-JP',
  'ko-KR',
  'ms-MY',
  'pl-PL',
  'ru-RU',
  'ro-RO',
  'th-TH',
  'vi-VN',
  'zh-HK',
  'zh-TW'
]);

/** 国际零售学堂支持语言配置 */
const miTrainingLangOptions: ILangConfig[] = getLangOptions([
  'zh-CN',
  'en-US',
  'en-GB',
  'ar-MA',
  'ar-SA',
  'es-419',
  'es-ES',
  'fr-FR',
  'id-ID',
  'ja-JP',
  'ko-KR',
  'ms-MY',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'th-TH',
  'vi-VN',
  'zh-HK',
  'zh-TW'
]);

interface ILangConfig {
  label: string;
  value: TLocale;
}

export const projectLangs: Record<string, ILangConfig[]> = {
  default: dualLangOptions,
  attendance: allLangOptions,
  'global-channel-retail': dualLangOptions,
  'global-retail-task-center': newRetailLangOptions,
  'global-retail-workbench': allLangOptions,
  'global-retail': newRetailLangOptions,
  'global-training': trainingLangOptions,
  'global-brain-platform': dualLangOptions,
  'global-store-inspection': dualLangOptions,
  'global-neural-center': dualLangOptions,
  'global-position-patrol': dualLangOptions,
  'global-retail-operation': miTrainingLangOptions,
  goods: allLangOptions,
  inventory: allLangOptions,
  training: miTrainingLangOptions,
  'retail-approval': allLangOptions,
  'staff-incentives': allLangOptions,
  'retail-message': allLangOptions,
  '330-migration': dualLangOptions
};
